import { render, staticRenderFns } from "./KategoriPenyaluranDanaPopup.vue?vue&type=template&id=5868bd82"
import script from "./KategoriPenyaluranDanaPopup.vue?vue&type=script&lang=js"
export * from "./KategoriPenyaluranDanaPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports